import { call, put } from 'redux-saga/effects';
import { setAllUserRightsSuccess, setUserRightsFailure } from '../actions';
import { ApiError, ApiResponse } from 'store/api/types';
import { checkResponse } from 'store/utils';
import { setAllUserRights } from '../api';
import { MessageData } from 'store/app/types';
import { turnMessageOn } from 'store/app/actions';
import { SetAllUserRightsRequestAction } from '../types';
import { updateEntityMembersBulk } from 'store/organisation/actions';
import { logoutRequest } from 'store/auth/actions';
import { renderErrorMessage } from 'utils/render-error-message';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* setAllUserRightsSaga(action: SetAllUserRightsRequestAction) {
  try {
    let err: ApiError | null;
    const { userRights, tablePermission, user } = action.payload;
    const response: ApiResponse = yield call(
      setAllUserRights,
      userRights[0].accountUuid,
      tablePermission
    );
    err = checkResponse(response?.responseMessage);
    if (err) throw err;
    // Batch update: single success action instead of per-item
    yield put(setAllUserRightsSuccess(userRights, tablePermission));
    // Optional: batch update entity members if "user" present
    if (user) {
      const items = userRights.map((ur) => ({
        organisationId: ur.organisationId,
        member: user,
        tablePermission,
      }));
      yield put(updateEntityMembersBulk(items));
    }
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(setUserRightsFailure());
  }
}
